<template>
  <main class="thanks-page">
    <section class="thanks-card">
      <div
        class="hero-icon mx-auto mb-4 d-flex align-items-center justify-content-center"
      >
        <i class="fa fa-check-circle"></i>
      </div>
      <h1>Gracias por tu participacion</h1>
      <p class="body-text">
        La informacion proporcionada nos ayudara a mejorar la calidad de
        nuestros cursos de capacitacion. BAESSH agradece tu tiempo y
        colaboracion.
      </p>
      <a
        class="btn btn-primary-custom btn-lg px-4 mt-3"
        href="https://www.baessh.com.mx"
        target="_blank"
        rel="noopener"
      >
        <i class="fas fa-globe mr-2"></i>
        Conocer mas sobre BAESSH
      </a>
    </section>
  </main>
</template>

<script>
export default {
  name: "EncuestaCapacitacionGracias",
};
</script>

<style scoped>
.thanks-page {
  min-height: 100vh;
  background: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 14px;
  text-align: center;
  color: #172033;
}

.thanks-card {
  width: 100%;
  max-width: 620px;
  background: #ffffff;
  border-radius: 0.8rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  padding: 42px 24px;
}

.hero-icon {
  width: 92px;
  height: 92px;
  border-radius: 999px;
  background: #dcfce7;
  color: #16a34a;
  font-size: 54px;
}

h1 {
  font-size: 30px;
  font-weight: 800;
  line-height: 1.15;
  margin-bottom: 12px;
}

.lead-text {
  color: #27384b;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 10px;
}

.body-text {
  color: #5b6878;
  font-size: 16px;
  line-height: 1.55;
  max-width: 480px;
  margin: 0 auto;
}

.btn-primary-custom {
  background-color: #136dec;
  border-color: #136dec;
  color: #ffffff;
  border-radius: 0.8rem;
  font-weight: 700;
}

.btn-primary-custom:hover {
  background-color: #0e56b9;
  border-color: #0e56b9;
  color: #ffffff;
}
</style>
